import { handlingCollegeErrors } from "./handling-college-errors-helpers";
import { BASE_URL_ONBOARDING } from "./index";
import { requestGetWithTemplate } from "./service-request-template";
import { GA_EVENTS } from "./tracker/ga.types";
import { CollegeListResponse } from "./types/college.entity";

export const getCollegeListService = async () => {
  return requestGetWithTemplate<CollegeListResponse>({
    url: `${BASE_URL_ONBOARDING}/onboardings/campaigns/colleges?LISTADO_COLEGIOS`,
    errorUrl: `in the get /onboardings/campaigns/colleges`,
    onHttpErrorMessage: "Error in the get college status by userId",
    onUnknownErrorLogMessage: `Unknown error in the get /onboardings/campaigns/colleges`,
    emptyData: {} as CollegeListResponse,
    handleError: handlingCollegeErrors,
    errorEventName: GA_EVENTS.ERRORS.REQUEST_COLLEGE_STATUS,
  });
};
